module.exports = __webpack_public_path__ + "img/cart-buy-hen.b601180e.png";